/**
 * Auth endpoint wrappers (the cookie-bearing surface).
 *
 * `refresh` is the linchpin: called at cold boot and by the factory's
 * silent-refresh interceptor. `logout` is fired by the sign-out action.
 */
import { api } from './client';
import type { AuthTokenResponse } from './types';

export const authApi = {
  async refresh(): Promise<AuthTokenResponse> {
    const { data } = await api.post<AuthTokenResponse>('/api/auth/refresh', {});
    return data;
  },

  async logout(): Promise<void> {
    await api.post('/api/auth/logout', {});
  },
};
